import { apiErrorToToast } from "@/lib/utils";
import {
  removeUser,
  RemoveUserRequestParams,
} from "@/requests/users/remove-user.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";

type UserMutationVariables = RemoveUserRequestParams & {
  email: string;
};

export const useRemoveUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: UserMutationVariables) => removeUser(variables),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["companies", variables.companyId, "users"],
      });
      toast.success(`Has eliminado al usuario ${variables.email}`);
    },
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
  });
};
